import React, { Component } from 'react';
import { getMentionCounts } from '../async_utils';
import { FilterContainer } from 'js/academia_components/navs/filter/filter_container';
import { FilterItem } from 'js/academia_components/navs/filter/filter_item';
import { MentionsCardsContainer } from '../components/MentionsCardContainer';
import { $, $r } from 'global';
import commaizeInt from 'js/utils/commaize';
import { FILTER_TO_API_FORMAT } from '../common';
import { trackClick } from 'js/utils/trackClick';
export class MentionsRouteContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.defaultToHighConfidence ? 'high_confidence' : 'all',
      counts: {},
      sortBy: 'relevance',
    };
  }

  componentDidMount() {
    $.post(
      $r.mark_all_as_read_api_v0_mentions_path({ subdomain_param: 'api' }),
    );
    this.getPremiumCounts();
  }

  handleCountsChange = (counts, sum) => {
    let state = this.state;
    if (sum) {
      state = {
        ...state,
        counts: Object.keys(counts).reduce(
          (memo, key) => ({ ...memo, [key]: (memo[key] || 0) + counts[key] }),
          { ...state.counts },
        ),
      };
    } else {
      state = {
        ...state,
        counts,
      };
    }
    if (
      state.filter === 'high_confidence' &&
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line eqeqeq
      state.counts['high_confidence'] == 0
    ) {
      // switch to all if no high confidence
      state = {
        ...state,
        filter: 'all',
      };
    }
    this.setState(state);
  };

  handleFilterChange = (filter) => () => {
    trackClick({
      source: 'mentions.filter_change',
      extra: {
        from_filter: FILTER_TO_API_FORMAT[this.state.filter],
        to_filter: FILTER_TO_API_FORMAT[filter],
        view_type: 'default',
      },
    });

    this.setState({ filter });
  };

  handleSortChange = (sortBy) => {
    if (sortBy === this.state.sortBy) return;
    this.setState({ sortBy });
  };

  getPremiumCounts = () => {
    getMentionCounts().then(({ counts }) => {
      this.handleCountsChange(counts);
    });
  };

  render() {
    if (this.props.underMaintenance) {
      return (
        <div style={{ width: '100%', height: 600, position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '18px',
              textAlign: 'center',
            }}
          >
            Apologies, the Mentions feature is undergoing a brief maintenance.
            Please try again in about an hour.
          </div>
        </div>
      );
    }
    if (this.props.isFeaturedCitationContext) {
      return (
        <FilterContainer
          className="MainHeaderContainer"
          content={this.renderContent()}
        >
          {this.renderFilterItem('all', 'All Mentions')}
        </FilterContainer>
      );
    }
    return (
      <FilterContainer
        className="MainHeaderContainer"
        content={this.renderContent()}
      >
        {this.renderFilterItem('all', 'All Mentions')}
        {this.renderFilterItem('high_confidence', 'High Confidence')}
        {this.renderFilterItem('is_me', 'This is Me')}
        {this.renderFilterItem('not_me', 'This is Not Me')}
      </FilterContainer>
    );
  }

  renderContent() {
    const counts =
      Object.keys(this.state.counts).length > 0 ? this.state.counts : null;
    return (
      <MentionsCardsContainer
        names={this.props.names}
        currentFilter={this.state.filter}
        sortBy={this.state.sortBy}
        onSortChange={
          !this.props.isFeaturedCitationContext
            ? this.handleSortChange
            : undefined
        }
        onCountChange={this.handleCountsChange}
        counts={counts}
        isFeaturedCitationContext={this.props.isFeaturedCitationContext}
        isBlurred={this.props.isBlurred}
        pricingCopy={this.props.pricingCopy}
        annualPrice={this.props.annualPrice}
        isTasteOfMentions={this.props.isTasteOfMentions}
        isTasteOfMentionsAutoclosing={this.props.isTasteOfMentionsAutoclosing}
      />
    );
  }

  renderFilterItem(filter, name) {
    const count = this.state.counts[filter];
    const positiveCount =
      typeof count === 'number' && count >= 0 ? count : undefined;
    return (
      <FilterItem
        onClick={this.handleFilterChange(filter)}
        active={this.state.filter === filter}
        rightText={commaizeInt(positiveCount)}
        disabled={this.state.counts[filter] === 0}
      >
        {name}
      </FilterItem>
    );
  }
}

export default MentionsRouteContainer;
